import { CorePagination } from '@/components/Pagination';
import CoreTable from '@/components/Table';
import { useCoreContext } from '@/core';
import { Typography } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { WardTableColumns } from '../../components/WardTableColumns';

export const WardTable = () => {
  const { loading, wardData, setValue, getValues } = useCoreContext();
  const tableColumns = WardTableColumns();

  return (
    <div>
      <CoreTable
        columns={tableColumns}
        dataSource={get(wardData, 'data', [])}
        tableName='Center'
        loading={loading}
      />
      <div className='flex mt-4 justify-between'>
        <Typography.Title level={3}>
          Total: {get(wardData, 'count') > 999 ? '>= 1000' : get(wardData, 'count')}
        </Typography.Title>
        <CorePagination
          total={get(wardData, 'count') ?? 0}
          defaultPageSize={10}
          showSizeChanger
          pageSizeOptions={['5', '10', '20']}
          onChange={(page, pageSize) => {
            setValue('page', page);
            setValue('limit', pageSize);
          }}
          current={getValues('page')}
        />
      </div>
    </div>
  );
};
